import React from 'react';
import  BgVideo from '../containers/BgVideo';
import ErrorHandler from '../helpers/ErrorHandler';
import config from '../config/app.json';
import { fromJS } from 'immutable';
import { errorlog } from '../helpers/ErrorLogService';
import { FormattedMessage } from 'react-intl';


class ShortcutsPopup extends React.Component {
    constructor(props){
        super(props);
        this.state = {currentTab : 0};
        this.shortCuts = fromJS([
            {name : "Slides", langId: 'k.st.sl', shortcuts : [
                {name : "Add Slide",langId: 'k.st.as', keys : ["ctrl", "m"]},
                {name : "Select Next Slide",langId: 'k.st.sns', keys : ["↓"]},
                {name : "Select Previous Slide",langId: 'k.st.sps' ,keys : ["↑"]},
                {name : "Move Slide Up",langId: 'k.st.msu', keys : ["ctrl", "↑"]},
                {name : "Move Slide Down", langId: 'k.st.msd',keys : ["ctrl", "↓"]},
                {name : "Move Slide First", langId: 'k.st.msf',keys : ["ctrl", "shift", "↑"]},
                {name : "Move Slide Last", langId: 'k.st.msl',keys : ["ctrl", "shift", "↓"]},
                {name : "Duplicate Slide",langId: 'k.st.ds', keys : ["ctrl", "d"]},
                {name : "Delete Slide",langId: 'k.st.dsc', keys : ["Delete\\Backspace"]},
                {name : "Select Multiple Slide",langId: 'k.st.sms', keys : ["ctrl", "click"]},
                {name : "Change Transition",langId: 'k.st.ctr', keys : ["shift", "t"]},
            ]},
            {name : "Menubar",  langId: 'k.st.mu',shortcuts : [
                {name : "Undo", langId: 'k.st.undo',keys : ["ctrl", "z"]},
                {name : "Redo",  langId: 'k.st.redo',keys : ["ctrl", "y"]}
            ]},
            {name : "Text", langId: 'k.st.txt',shortcuts : [
                {name : "Align Right", langId: 'k.st.alr',keys : ["ctrl", "shift", "r"]},
                {name : "Align Left", langId: 'k.st.all',keys : ["ctrl", "shift", "l"]},
                {name : "Align Center", langId: 'k.st.alc',keys : ["ctrl", "shift", "e"]},
                {name : "To Uppercase", langId: 'k.st.toup',keys : ["ctrl", "shift", "u"]},
                {name : "To Lowercase", langId: 'k.st.tolo',keys : ["ctrl", "shift", "s"]},
                {name : "To Capitalize", langId: 'k.st.tocap',keys : ["ctrl", "shift", "c"]},
                {name : "To Removecase", langId: 'k.st.torem',keys : ["ctrl", '\\']},
                {name : "Set Bold", langId: 'k.st.sebo',keys : ["ctrl", "b"]},
                {name : "Set Italic", langId: 'k.st.seit',keys : ["ctrl", "i"]},
                {name : "Increase Font Size", langId: 'k.st.infs',keys : ["ctrl", "shift", ">"]},
                {name : "Decrease Font Size", langId: 'k.st.defs',keys : ["ctrl", "shift", "<"]},
                {name : "Change Font Family", langId: 'k.st.chff',keys : ["ctrl", "shift", "f"]}
            ]},
            {name : "Player", langId: 'k.st.ply',shortcuts : [
                {name : "Previous Slide", langId: 'k.st.prev',keys : ["Left Arrow"]},
                {name : "Next Slide", langId: 'k.st.next', keys : ["Right Arrow"]},
            ]},
            {name : "Workspace", langId: 'k.st.wrk',shortcuts : [
                {name : "Move Object Down 10px", langId: 'k.st.modo',keys : ["↓"]},
                {name : "Move Object Top 10px", langId: 'k.st.moto',keys : ["↑"]},
                {name : "Move Object Left 10px", langId: 'k.st.molof',keys : ["←"]},
                {name : "Move Object Right 10px", langId: 'k.st.moro',keys : ["→"]},
                {name : "Move Object Down 1px", langId: 'k.st.modd',keys : ["shift", "↓"]},
                {name : "Move Object Top 1px", langId: 'k.st.mott',keys : ["shift", "↑"]},
                {name : "Move Object Left 1px", langId: 'k.st.moll',keys : ["shift", "←"]},
                {name : "Move Object Right 1px", langId: 'k.st.morri',keys : ["shift", "→"]},
                {name : "Select All Objects", langId: 'k.st.saob',keys : ["ctrl", "a"]},
                {name : "Deselect All Objects", langId: 'k.st.deao',keys : ["ctrl", "shift", "a"]},
                {name : "Select Multiple Objects", langId: 'k.st.smobj',keys : ["ctrl", "click"]},
                {name : "Open/Close settings", langId: 'k.st.ocse',keys : ["shift","s"]},
                {name : "Copy Item", langId: 'k.st.coit',keys : ["ctrl", "c"]},
                {name : "Cut Item", langId: 'k.st.cuit',keys : ["ctrl", "x"]},
                {name : "Paste Item", langId: 'k.st.pait',keys : ["ctrl", "v"]},
                {name : "Delete Item", langId: 'k.st.deits',keys : ["Delete\\Backspace"]},
                {name : "Zoom In", langId: 'k.st.zoin',keys : ["ctrl", "alt", "+"]},
                {name : "Zoom Out", langId: 'k.st.zout',keys : ["ctrl", "alt", "-"]},
                {name : "Bring Front", langId: 'k.st.brfro',keys : ["ctrl", "shift", "↑"]},
                {name : "Move Last", langId: 'k.st.molas',keys : ["ctrl", "shift", "↓"]},
                {name : "Bring First", langId: 'k.st.brfri',keys : ["ctrl", "↑"]},
                {name : "Move Back", langId: 'k.st.mobac',keys : ["ctrl", "↓"]},
                {name : "Flip Item", langId: 'k.st.flite',keys : ["alt", "f"]},
                {name : "Group Item", langId: 'k.st.grpit',keys : ["ctrl", "alt", "g"]},
                {name : "Ungroup Item", langId: 'k.st.ungrit',keys : ["ctrl", "alt", "shift", "g"]},
            ]},
            {name : "Library", langId: 'k.st.liby',shortcuts : [
                {name : "Open Prebuild", langId: 'k.st.oppre',keys : ["shift", "1"]},
                {name : "Open Character", langId: 'k.st.opchr',keys : ["shift", "2"]},
                {name : "Open Properties", langId: 'k.st.oppro',keys : ["shift", "3"]},
                {name : "Open Text", langId: 'k.st.potxt',keys : ["shift", "4"]},
                {name : "Open Background", langId: 'k.st.opbck',keys : ["shift", "5"]},
                {name : "Open Image", langId: 'k.st.opimg',keys : ["shift", "6"]},
                {name : "Open Uploads", langId: 'k.st.opupl',keys : ["shift", "7"]},
            ]},
        ]);
        this.changeTab      =   this.changeTab.bind(this);
    }

    changeTab(currentTab){
        try {
        this.setState({currentTab : currentTab});
        } catch (error) {
            //Error Severity: LOW
            errorlog(error, error.message, "CommonPopup-changeTab");
        }
    }

    render(){
        let tabs =[];
        let content = [];
        var macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],os=null;
        if (macosPlatforms.indexOf(window.navigator.platform) !== -1) 
            os = 'Mac';
        else
            os = "Windows"
        this.shortCuts.map(function(item, idx){
            tabs.push(<li key = {idx} className = {this.state.currentTab === idx ? "active": this.state.currentTab === idx + 1 ? "prev" : this.state.currentTab === idx - 1 ? "next":""} onClick = {(e) => this.changeTab(idx)}><FormattedMessage id={`${item.get("langId")}`}></FormattedMessage></li>);
            if(idx === this.state.currentTab && item.get("shortcuts").size > 0){
                item.get("shortcuts").map(function(sItem, sIdx){
                    let keys = [];
                    if(sItem.get("keys").size > 0){
                        sItem.get("keys").map(function(KItem, kIdx){
                            if(os === "Mac")
                            {
                                if(KItem==='ctrl')
                                    KItem='cmd'
                                else if(KItem==='alt')
                                    KItem='opt'
                            }
                            keys.push(<span key={kIdx}>{KItem}</span>);
                        })
                    }
                    content.push(<li key = {sIdx}><FormattedMessage id={`${sItem.get("langId")}`}></FormattedMessage><div>{keys}</div></li>);
                }.bind(this));
                
            }
        }.bind(this));
        return(
            <div className="shortcut-popup popup-tool-bar">
                <div className = "popup-header"><FormattedMessage id='m.keyboard.shortcuts'></FormattedMessage></div>
                <div className = "popup-body">
                    <div className = "popup-tabs-nav">
                        <ul>
                            <li className = {this.state.currentTab === 0 ? "prev" : ""}></li>
                            {tabs}
                            <li className = {this.state.currentTab === tabs.length - 1 ? "next" : ""}></li>
                        </ul>
                    </div>
                    <div className = "popup-tabs-container">
                        <ul>
                            {content}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

class AnmsPopup extends React.Component {
    constructor(props){
        super(props);
        this.apiUrl = config['APIURIS'][config['APIURIS']['current']];
        this.animPopupClosed    =   this.animPopupClosed.bind(this);
        this.popupContent = {
            "anmsPopup1":{
                "header" : "Create Stunning Animated and Live Videos yourself!",
                "content_1" : "Our free Drag-And-Drop video maker makes it easy for anyone to create stunning videos using pre-made templates and ready-to-go assets.No Technical knowledge required.",
                "content_header" : "Join over 4,000,000 people already using Animaker",
                "button" : "Create your first video",
                "isSignup" : false,
                "button_tag" : "Free, Forever, No Credit Card required",
            },
            "anmsPopup2":{
                "header" : "Rapid Video Creation with Point-and-Click simplicity",
                "content_1" : "With Animaker's Lite Mode, just Point, Click and Swap stuff. No dragging and dropping required. Create a professional video in SECONDS!!!",
                "button" : "Create your first video",
                "isSignup" : false,
                "button_tag" : "Free, Forever, No Credit Card required",
            },
            "anmsPopup3":{
                "header" : "Make and Edit Videos together with your team",
                "content_1" : "Sign Up and share this Video Project with your Team Members.",
                "button" : "Create your first video",
                "isSignup" : false,
                "button_tag" : "Free, Forever, No Credit Card required",
            },
            "anmsPopup4":{
                "header" : "Sign Up to Save and Rename Your Video",
                "content_1" : "Access and e-Edit your videos from anywhere. Your videos are protected with Best-In-Class Security Tools",
                "button" : "Sign me up",
                "isSignup" : true,
                "button_tag" : "Free, Forever, No Credit Card required",
            }
        }
    }

    signup(){
        try {
        this.props.setWorkspaceTextFocus(true);
        let uploadId = this.props.workspaceBG.get("assetId");
        window.anonymousUserExport({uploadId : uploadId, type : "signup"}).then(function(result){
            this.props.setWorkspaceTextFocus(false);
            if(!result.error){
                if(result.hit === "signup" || result.hit === "login"){
                    document.getElementById("app-overlay").style.display = "block";
                    document.getElementById("app-overlay").style.zIndex = "2000";
                    document.getElementById("app-overlay").style.backgroundColor = "rgba(0,0,0,0.5)";
                    document.getElementById("app-overlay").style.backgroundImage = "url("+this.appUrl+"/images/chr-loading.svg)";
                    document.getElementById("app-overlay").style.backgroundPosition = "center";
                    document.getElementById("app-overlay").style.backgroundRepeat = "no-repeat";
                    document.getElementById("app-overlay").className = "overlayDom-tool-bar";
                    window.location = this.apiUrl + "customproject/"+result.projectId;
                }
            }else {
                this.props.closePopup();
                if(result.errorMsg !== undefined)
                    this.props.manageToast({action : "add", type : "error", "message" : "common.toast.msg", subMessage : result.errorMsg, formatId: 'msg'});
            }
        }.bind(this), (error)=>{
            this.props.closePopup();
            this.props.setWorkspaceTextFocus(false);this.props.manageToast({action : "add", type : "error", "message" : "common.toast.msg", formatId: 'msg'}) })
        }catch (error) {
            //Error Severity: LOW
            errorlog(error, error.message, "CommonPopup-signup");
        }
    }

    componentDidMount(){
        window.addEventListener('POPUPCLOSE', this.animPopupClosed, false);
    }

    animPopupClosed(e){
        try {
        this.props.setWorkspaceTextFocus(false);
        } catch (error) {
            //Error Severity: LOW
            errorlog(error, error.message, "CommonPopup-animPopupClosed");
        }
    }

    componentWillUnmount()
    {
        window.removeEventListener('POPUPCLOSE', this.animPopupClosed, false);
    }

    render(){
        let thisContent = this.popupContent[this.props.data.get("popup")];
        return(
        <div className = "anms-popup">
            <div className = "anms-popup-header">
            <div className = "anms-container" dangerouslySetInnerHTML={{__html: thisContent.header}}></div>
            </div>
            <div className = "anms-popup-content">
                <div className = "anms-container flex">
                    <div className = "content-1">{thisContent.content_1}</div>
                    {thisContent.content_header !== undefined?<div className = "content-header">{thisContent.content_header}</div>:null}
                    {thisContent.button !== undefined?<div onClick = {(e) => this.signup()} className = "popup-btn">{thisContent.button}</div>:null}
                    {thisContent.button_tag !== undefined?<div className = "popup-btn-tag">{thisContent.button_tag}</div>:null}
                </div>
            </div>
        </div>
        );
    }
}

class BrandPopup extends React.Component {
    constructor(props){
        super(props);
        this.apiUrl = config['APIURIS'][config['APIURIS']['current']];
        
    }

    render(){
        return(
        <div className = "brand-popup">
            <div className = "brand-popup-header">
            <FormattedMessage id="un.to.st"></FormattedMessage>
            </div>
            <div className = "brand-content">
                <div className = "brand-container flex">
                    {/* <div className = "content-1">Unable to Save as Template</div> */}
                    <div className = "brand-header"><FormattedMessage id="li.ex.sat"></FormattedMessage></div>
                    {<div className = "brand-btn" onClick = {(e) => {
                        this.props.cancelPopup();
                        window.open(config["APIURIS"][config["APIURIS"]["current"]] + 'brand', '_blank');
                    }}><FormattedMessage id="re.tx"></FormattedMessage></div>}
                </div>
            </div>
        </div>
        );
    }
}

class CommonPopupComponent extends React.Component {
    
    constructor(props){
        super(props);
        this.appUrl = config['APPICONS'][config['APPICONS']['current']]
        this.state= {
            popupDisplay:'none',
            responsiveWidth : '',
            responsiveHeight : ''
        }

        this.ClosePopup = this.ClosePopup.bind(this);
        this.applyCss = this.applyCss.bind(this);
        this.popWidth = 1152;
        this.popHeight = 450;
      
        
    }

    componentDidMount(){
        window.addEventListener('resize', this.applyCss, false);
        
        if(this.popWidth > window.innerWidth || this.popHeight > window.innerHeight){
            this.applyCss(window.innerWidth, window.innerHeight, 'start');
        }
    }

    componentWillReceiveProps(nextProps, nextState){
        if(nextProps.commonPopup.toJS().popup  !== this.props.commonPopup.toJS().popup ){
            if(nextProps.commonPopup.toJS().popup === 'VIDEO')
                this.popWidth = 800;
                this.popHeight = 450;

            this.setState({
                responsiveWidth : this.popWidth,
                responsiveHeight : this.popHeight,
                windowHeight : window.innerHeight,
                windowWidth : window.innerWidth,
            })
        }
    }

    componentWillUnmount(){
        window.removeEventListener('resize', this.applyCss, false);
    }


    applyCss(alignWidth, alignHeight, position){
        try {
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
        var setWidth;
        var setHeight;
        if(position === 'start'){
            setWidth = alignWidth-100;
            if(this.windowHeight > this.popHeight){
                setHeight = this.popHeight-((this.popHeight*2.56)/100)-100/2.56;
            }
          }else{
              if(this.props.commonPopup.toJS().show){
                let innerPopup = document.querySelector('.common-popup').getElementsByClassName('common-popup-inner')[0];
                setWidth = innerPopup.offsetWidth;
                setHeight = innerPopup.offsetHeight;
              }else{
                if(this.popWidth > window.innerWidth || this.popHeight > window.innerHeight){
                    setWidth = window.innerWidth-100;
                    if(this.windowHeight > this.popHeight){
                        setHeight = this.popHeight-((this.popHeight*2.56)/100)-100/2.56;
                    }
                }else{
                    setWidth = this.popWidth;
                    setHeight = this.popHeight;
                }
              }
        }
        if(this.props.commonPopup.toJS().show){
            if(this.state.windowWidth > window.innerWidth || this.state.windowHeight > window.innerHeight){
                if((setWidth > window.innerWidth/2 && setWidth >= 924) || (setHeight > window.innerHeight/2 && setHeight >= 640)){
                    setWidth =  setWidth - ( (setWidth*2.56/100));
                    setHeight = setHeight - ((setHeight*1/100));
                }
            }else{
                if(((setWidth < this.popWidth)  && (window.innerWidth >= 1024 && window.innerHeight >= 700)) || ((setHeight < this.popHeight) && (window.innerWidth >= 1024 && window.innerHeight >= 700))){
                        setWidth =  setWidth + ( (setWidth*2.56/100));
                        setHeight = setHeight + ((setHeight*1/100));
                }else if(window.innerWidth > this.popWidth && window.innerHeight> this.popHeight ){
                    setWidth = this.popWidth;
                    setHeight = this.popHeight;
                }
            }
        }


        this.setState({
            responsiveWidth : setWidth,
            responsiveHeight : setHeight,
            windowHeight : window.innerHeight,
            windowWidth : window.innerWidth,
        })
        } catch (error) {
            //Error Severity: LOW
            errorlog(error, error.message, "CommonPopup-applyCss");
        }

    }
    
    ClosePopup(e=null, status=null){
        try {
        if(status === 'outside'){
            if(!this.isMouseOn(e, "common-popup-inner") && this.props.commonPopup.toJS().popup === 'VIDEO'){
                this.setState({popupDisplay:'none'});
                this.props.openCommonPopup(null,false);                            
            }
        }else{
            this.setState({popupDisplay:'none'});
            this.props.openCommonPopup(null,false);
        }
        } catch (error) {
            //Error Severity: LOW
            errorlog(error, error.message, "CommonPopup-ClosePopup");
        }
    }

    isMouseOn(e, value) {
        try {
        var i;
        var path_array = e.path || (e.composedPath && e.composedPath()) || this.composedPath(e.target);
        
        if (path_array.length > 0) {
          for (i = 0; i < path_array.length; i++) {
            if (path_array[i].className !== undefined && typeof (path_array[i].className) !== "object") {
    
              if (path_array[i].className.indexOf(value) !== -1) {
                return true;
              }
            }
            else if (path_array[i].className !== undefined && typeof (path_array[i].className) === "object") {
              if (path_array[i].className.animVal.indexOf(value) !== -1)
                return true;
            }
          }
        }
        return false;
        } catch (error) {
            //Error Severity: LOW
            errorlog(error, error.message, "CommonPopup-isMouseOn");
        }
    }

    composedPath(el) {
        var path = [];
        while (el) {
          path.push(el);
          if (el.tagName === 'HTML') {
            path.push(document);
            path.push(window);
            return path;
          }
          el = el.parentElement;
        }
    }
    render(){
        let visibility = (this.props.commonPopup.toJS().show ) ? 'block' : 'none';
        let stylePopup = {};
        let popupType = this.props.commonPopup.toJS().popup;
        if(this.props.commonPopup.toJS().show){
            if(this.props.commonPopup.toJS().popup === "VIDEO")
                stylePopup = {width : this.state.responsiveWidth+'px', height: this.state.responsiveHeight+'px', zIndex: 1};
            else if(this.props.commonPopup.toJS().popup === "SHORTCUT")
                stylePopup = {width : "990px", height: "auto", zIndex: 1};
            else if(popupType && popupType.indexOf("anms") !== -1)
                stylePopup = {width : "550px", height: "auto", zIndex: 1};
            else if(popupType === "brandExceeds"){
                stylePopup = {width : "550px", height: "auto", zIndex: 1, backgroundColor : "#fff"};
            }
        } 
        
        let videoSliderHeight = (document.getElementById('videoSLiderDiv') !== null && document.getElementById('videoSLiderDiv') !== undefined) ? document.getElementById('videoSLiderDiv').offsetHeight : null;
        return(
            <div data-html2canvas-ignore="true" className={'common-popup tool-bar' + (popupType && popupType.indexOf("anms") !== -1?" anms":"")} style={{display:visibility}} onMouseDown={(e)=>{this.ClosePopup(e,'outside')}}>
                <div className='common-popup-inner' style={stylePopup}>
                <div className="close-button bgvideo-close">
                    <img src={this.appUrl + "/images/cancel-normal.svg"} onClick={()=>{this.ClosePopup()}}/>
                </div>
                    {(this.props.commonPopup.toJS().popup === "VIDEO")?<ErrorHandler component = "BgVideo"><BgVideo changedDimensions={videoSliderHeight} cancelPopup = {this.ClosePopup}  socket={this.props.socket}/></ErrorHandler>:null}
                    {(this.props.commonPopup.toJS().popup === "SHORTCUT")?<ErrorHandler component = "SHORTCUT"><ShortcutsPopup socket={this.props.socket} userId = {this.props.userId}/></ErrorHandler>:null}
                    {(popupType && popupType.indexOf("anms") !== -1)?<ErrorHandler component = "ANMSPOPUP"><AnmsPopup socket={this.props.socket} data = {this.props.commonPopup} userId = {this.props.userId} workspaceBG = {this.props.workspaceBG} setWorkspaceTextFocus = {this.props.setWorkspaceTextFocus} updateUserDetails = {this.props.updateUserDetails} manageToast = {this.props.manageToast} closePopup = {this.ClosePopup}/></ErrorHandler>:null}
                    {(this.props.commonPopup.toJS().popup === "brandExceeds")?<ErrorHandler component = "brandExceeds"><BrandPopup socket={this.props.socket} userId = {this.props.userId} cancelPopup = {this.ClosePopup}/></ErrorHandler>:null}
                </div>
            </div>
        )};
}

export default CommonPopupComponent;


// WEBPACK FOOTER //
// ./src/components/CommonPopupComponent.js